import React, { ChangeEvent, KeyboardEvent, useRef, useState } from "react";

interface OTPInputProps {
  length: number;
  onComplete: (otp: string) => void;
  disabled?: boolean;
}

const OTPInput: React.FC<OTPInputProps> = ({
  length,
  onComplete,
  disabled,
}) => {
  const [otp, setOtp] = useState<string[]>(new Array(length).fill(""));
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = event.target.value;
    const newOtp = [...otp];

    if (isNaN(Number(value))) {
      return;
    }

    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }

    if (newOtp.every((item) => item.length === 1)) {
      onComplete(newOtp.join(""));
    }
  };

  const handleKeyDown = (
    event: KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    // Allow users to use backspace to clear the current field and focus the previous one
    if (event.key === "Backspace") {
      if (!otp[index] && index > 0) {
        inputsRef.current[index - 1]?.focus();
      }
    }
  };

  return (
    <div className="flex justify-center space-x-2">
      {otp.map((_, index) => (
        <input
          key={index}
          type="text"
          inputMode="numeric"
          maxLength={1}
          disabled={disabled}
          value={otp[index]}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={(e) => {
            e.preventDefault();
            const pastedText = e.clipboardData.getData("text/plain");
            if (!isNaN(Number(pastedText))) {
              setOtp(
                new Array(length)
                  .fill("")
                  .map((_, index) => Array.from(pastedText)[index])
              );
              if (Array.from(pastedText).length >= 5) {
                onComplete(Array.from(pastedText).slice(0, 5).join(""));
              }
            }
          }}
          className="w-10 h-10 text-lg text-center border border-gray-300 rounded shadow-sm form-control focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
          ref={(el) => (inputsRef.current[index] = el)}
          onFocus={(e) => e.target.select()}
        />
      ))}
    </div>
  );
};

export default OTPInput;
